var exports = {
  "wx": "header__oZ3TFo",
  "Qs": "content__1DTBDH",
  "R_": "heading__7814cm",
  "fV": "subheading__2S9LD_",
};

module.exports = exports;
